(function () {
	'use strict';

	// ─── Heading word animation ─────────────────────────────────────────────────
	// Ported from the luigetiigi site. Headings with the "animate-words" global
	// class (or a classic heading widget with it under Advanced > CSS Classes) fade
	// up word by word when they scroll into view, and fade back out when scrolled
	// back above. SplitText keeps inner markup (<br>, links, spans) and adds an
	// aria-label so screen readers still read the heading as one phrase. The
	// heading is hidden until it is split (_animate-words.scss); .is-split shows it.

	var SELECTOR = '.animate-words';

	function animate(el) {
		var heading = el.querySelector('.elementor-heading-title') || el;
		var split = window.SplitText.create(heading, {
			type: 'words',
			tag: 'span',
			wordsClass: 'animate-words__word',
			aria: 'auto',
		});

		el.classList.add('is-split');

		window.gsap.from(split.words, {
			scrollTrigger: {
				trigger: heading,
				start: 'top 90%',
				toggleActions: 'play none none reverse',
			},
			opacity: 0,
			y: 20,
			duration: 0.6,
			ease: 'power2.out',
			stagger: 0.1,
		});
	}

	document.addEventListener('DOMContentLoaded', function () {
		var elements = Array.prototype.slice.call(document.querySelectorAll(SELECTOR));
		if (!elements.length || !document.documentElement.classList.contains('arelis-motion')) {
			return;
		}

		var canAnimate = window.gsap && window.ScrollTrigger && window.SplitText &&
			!window.matchMedia('(prefers-reduced-motion: reduce)').matches;

		if (!canAnimate) {
			elements.forEach(function (el) {
				el.classList.add('is-split');
			});
			return;
		}

		window.gsap.registerPlugin(window.ScrollTrigger, window.SplitText);
		elements.forEach(animate);
	});

})();
